import React from "react";
import { useTranslation } from "react-i18next";

// Images & Icons
import pp_judges_1 from "assets/images/judges/pp_judges_1.jpg";
import pp_judges_2 from "assets/images/judges/pp_judges_2.png";
import pp_judges_3 from "assets/images/judges/pp_judges_3.png";
import pp_judges_4 from "assets/images/judges/pp_judges_4.jpeg";
import pp_judges_5 from "assets/images/judges/pp_judges_5.jpg";
import pp_judges_6 from "assets/images/judges/pp_judges_6.png";
import pp_judges_7 from "assets/images/judges/pp_judges_7.jpeg";
import pp_judges_8 from "assets/images/judges/pp_judges_8.jpeg";

const Judges = () => {
  const { t } = useTranslation();

  const judges_row_1 = [
    {
      name: "Brigitte Schaden",
      role: "President of Project Management Austria (PMA) and Chair of the Global Alliance for the Project Professions (GAPPS)",
      img_url: pp_judges_1,
    },
    {
      name: "Prof. Dr. Lynn Crawford",
      role: "Honorary Professor in the School of Project Management at Sydney University and the John Grill Institute for Project Leadership",
      img_url: pp_judges_2,
    },
    {
      name: "Tony Simmonds",
      role: "Director and Chief Executive Officer of Interlink Technology Services Pty Ltd (ITS) and Director for the Global Alliance for Project Performance Standards (GAPPS)",
      img_url: pp_judges_3,
    },
    {
      name: "Dr. Antonius Hari Prasetyo Moerdianto, SE, Ak., CA, MBA",
      role: "Director of The Indonesia Capital Market Institute (TICMI)",
      img_url: pp_judges_8,
    },
  ];

  const judges_row_2 = [
    {
      name: "Maria R Nindita Radyati, PhD",
      role: "Chair of the ESG Governance Committee",
      img_url: pp_judges_4,
    },
    {
      name: "Dr. Mulya Amri",
      role: "Executive Director KADIN Institute",
      img_url: pp_judges_5,
    },
    {
      name: "Antonius Sumarwan, PhD",
      role: "Head of the Master’s Program in ESG & Sustainability Management, Sanata Dharma University",
      img_url: pp_judges_6,
    },
    {
      name: "Dr. Amalia Yunita, MM-Sust.",
      role: "Chairman of IATTA – Indonesia Adventure Travel Trade Association",
      img_url: pp_judges_7,
    },
  ];

  return (
    <div>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start section-title">
            {t("judges")}
          </p>
          <div className="grid grid-cols-1 gap-20 sm:grid-cols-2 lg:grid-cols-4">
            {judges_row_1.map((judge, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center"
              >
                <div
                  className={`w-48 h-48 mb-6 rounded-full ${judge && judge.img_url ? "" : "bg-gray-300"}`}
                >
                  {judge && judge.img_url ? (
                    <img
                      className="object-cover w-48 h-48 rounded-full"
                      src={judge.img_url}
                      alt={`judges_${index}`}
                    />
                  ) : null}
                </div>

                <h3 className="text-[#0056A3] font-bold text-lg">
                  {judge.name}
                </h3>
                <p className="text-[#0056A3] text-base mb-4">{judge.role}</p>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-20 sm:grid-cols-2 lg:grid-cols-4">
            {judges_row_2.map((judge, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center"
              >
                <div
                  className={`w-48 h-48 mb-6 rounded-full ${judge && judge.img_url ? "" : "bg-gray-300"}`}
                >
                  {judge && judge.img_url ? (
                    <img
                      className="object-cover w-48 h-48 rounded-full"
                      src={judge.img_url}
                      alt={`judges_${index}`}
                    />
                  ) : null}
                </div>

                <h3 className="text-[#0056A3] font-bold text-lg">
                  {judge.name}
                </h3>
                <p className="text-[#0056A3] text-base mb-4">{judge.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Judges;
